import React from 'react';
import { Helmet } from 'react-helmet';
import Header from "../components/v3/Header";
import Hero from "../components/v3/Hero";
import Companies from "../components/v3/Companies";
import BlockMonitoring from "../components/v3/BlockMonitoring";
import Testimonials from "../components/Testimonials";
import Footer from '../components/Footer';
import SEO from '../components/seo';
import ProblemSolutionBlock from '../components/ProblemSolution/ProblemSolutionBlock';
import WhyChooseHyperping from '../components/v3/WhyChooseHyperping';
import BlockCTA from '../components/v3/BlockCTA';
import { buildRegisterUrl } from '../utils';

const Page = () => {
  const [registerUrl, setRegisterUrl] = React.useState('https://app.hyperping.io/register');
  
  // Update register URL with UTM parameters after component mounts
  React.useEffect(() => {
    setRegisterUrl(buildRegisterUrl());
  }, []);

  return (<div className="page">
    <Helmet htmlAttributes={{ theme: 'dark' }} />
    <SEO
      title="Hyperping | Uptime monitoring with public status pages"
      keywords={['uptime', 'monitoring', 'status page', 'uptime monitoring']}
      description="Uptime monitoring for websites and APIs, public status pages, instantly receive alerts by emails, Slack and SMS"
    />
    <Header />
    <Hero />
    <div className="mt-3em" />
    <Companies />
    <div className="mt-3em" />
    {/* <BlockProducts />
    <div className="mt-3em" /> */}
    <ProblemSolutionBlock
      title="Uptime monitoring & status page tools won't help you with SLAs and incident communication if…"
      points={[
        "You can't check all your critical systems because they're lackluster.",
      "Downtime notifications don't reach the channel where you're most likely to see them.",
        "Status pages are subpar resulting in miscommunication with customers.",
      ]}
      solution={"Hyperping unlocks reliable SLAs and incident management."}
    />
    <BlockMonitoring />
    <Testimonials />
    <div className="mb-5em" />
    <WhyChooseHyperping />
    <div className="mb5" />
    <BlockCTA 
      title="Get your uptime checks and status pages running in seconds"
      // description="Experience reliable uptime monitoring and status pages"
      buttonText="Start monitoring for free →"
      buttonLink={registerUrl}
      bulletPoints={[
        "15M checks every day",
        "Hosting 1000+ status pages",
        "Contact us if you need migration"
      ]}
      quote={{
        text: "“Hyperping has been instrumental in helping us maintain the high standards of performance and reliability our global clients expect.”",
        author: "Drago Crnjac",
        role: "CEO, SaaS Custom Domains",
      }}
    />
    <div className="mb5" />
    <Footer darkMode={true} />
  </div>);
};

export default Page;
